// @ts-nocheck
import React from "react";
import { VariationMenu } from "../../forecastGraphs/helpers/GraphMobileControls";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download-02.svg";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock-01.svg";
import { ReactComponent as DatasetsIcon } from "../../../assets/icons/layers-icon.svg";

// One stacked chart's own toolbar, stacked in a column down the right edge of its band: variation, time range, datasets and download, icons only. The time range and datasets openers come from the chart itself (it registers them), so each chart keeps its own range and visible datasets.
const StackedChartControls = ({ label, variations, variation, onVariationChange, controls, onDownload }) => {
  const iconButton = "eai-btn-toolbar-icon";
  // Pulled left (-ml-4) over the chart canvas' empty right gutter, where only the last x-axis date label hangs, so there is no dead gap between the axes and the buttons
  return (
    <div className="relative z-10 -ml-4 flex flex-none flex-col items-center gap-1.5 py-2">
      {variations?.length > 0 && (
        <VariationMenu
          buttonClassName={iconButton}
          showLabel={false}
          title={`Variation: ${variations.find((v) => v.key === variation)?.name ?? "Select"}`}
          variationOptions={variations.map((v) => ({ key: v.key, label: v.name }))}
          selectedVariationKey={variation}
          onSelectVariation={onVariationChange}
        />
      )}
      <button
        type="button"
        onClick={() => controls?.openTimeRange?.()}
        disabled={!controls?.openTimeRange}
        title="Select time range"
        aria-label={`Select time range for ${label}`}
        className={iconButton}
      >
        <ClockIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
      </button>
      <button
        type="button"
        onClick={() => controls?.openDataset?.()}
        disabled={!controls?.openDataset}
        title="Show or hide datasets"
        aria-label={`Toggle dataset visibility for ${label}`}
        className={iconButton}
      >
        <DatasetsIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
      </button>
      <button
        type="button"
        onClick={onDownload}
        title="Download CSV"
        aria-label={`Download CSV for ${label}`}
        className={iconButton}
      >
        <DownloadIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
      </button>
    </div>
  );
};

export default StackedChartControls;
